import React from 'react'
import { Link } from 'react-router-dom'
import { RiDownloadLine, RiMailAddFill, RiMailAddLine, RiMailFill } from '@remixicon/react'
import SlideUp from '../../utlits/animations/slideUp'

const CallToAction = () => {
    return (
        <section className="call-to-action-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <SlideUp>
                            <div className="about-content-part call-to-action-part text-center">
                                <h2>¿Listo para dar un impulso digital a tu negocio?</h2>
                                <p>Hablemos y hagámoslo posible. ¡No desaproveches el enorme potencial digital de tu compañía! ✨</p>
                                <div className="hero-btns">
                                    <a href="/contact" className="theme-btn">Contacta conmigo<i><RiMailFill size={16} /></i></a>
                                </div>
                            </div>
                        </SlideUp>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CallToAction